import React from "react";
import { TextWrap, Title, Text, Sorriso, Link, Button } from "./style";
import { useFetchContent } from "src/hooks/useContentful/useFetchContent";
import { getSection } from "src/hooks/useContentful/getSection";
import { eventTrack } from "src/components/GoogleTagManager";

export default function Mapa() {
  const { data, isLoading } = useFetchContent();
  const { description, title } = getSection({
    sectionName: "landingMapa",
    data,
  });

  return (
    <div>
      <TextWrap>
        <Title>{!data || isLoading ? "..." : title}</Title>
        <Sorriso />
        <Text>{!data || isLoading ? "..." : description}</Text>
        <Link href={"https://veloe.com.br/onde-usar/mapa/"}>
          <Button
            onClick={() => {
              eventTrack(
                'veloe:institucional',
                'clique:botao',
                'onde-usar:ver-cobertura'
              );
            }}
          >
            <p>Ver cobertura</p>
          </Button>
        </Link>
      </TextWrap>
    </div>
  );
}
